body {
  margin: 0;
  background-color: #0d0d0d;
  color: #ffffff;
  font-family: 'Inter', 'Noto Sans TC', system-ui, -apple-system, 'Segoe UI',
    'Roboto', 'Helvetica Neue', sans-serif;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
